import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { CoreService, InMemoryCacheService, UtilsService } from 'src/app/common';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GoogleAnalyticsKpiService {

    private _cache: { [key: string]: any } = {};

    private core = inject(CoreService<{}>);
    private utils = inject(UtilsService);
    private http = inject(HttpClient);
    private cache = inject(InMemoryCacheService);


    public async getAnalyticsQuery(params: any, handleError: boolean = false) : Promise<any>{

        const { data } = await this.cache.getGoogleAnalyticsData(params);
        return data;

    }
}
